/* eslint-disable no-unused-vars */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBYcDHdxpWi1LUJuTSs7aqJDTL0SyoYp6A",
    authDomain: "madis-1bac0.firebaseapp.com",
    projectId: "madis-1bac0",
    storageBucket: "madis-1bac0.appspot.com",
    messagingSenderId: "1056288545985",
    appId: "1:1056288545985:web:4eb60e7ac48fd9f6404840",
    measurementId: "G-LR8RXSZQ5C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestoredb = getFirestore(app)
const auth = getAuth(app);
const storage = getStorage(app);



export { firestoredb, auth, storage }